/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'

/**
 * Typescript enum
 */

export enum Permissions {
  view_some_other_type = 'view_some_other_type',
  view_some_type = 'view_some_type'
}

/**
 * Permissions
 *
 * The permissions available for different membership types
 */
export const PermissionsEnumType = types.enumeration('Permissions', ['view_some_other_type', 'view_some_type'])
